import React from 'react';
import { Link } from 'react-router-dom';
import styles from './CTAGroup.module.css';
import { useGetStarted } from './GetStartedContext';
import { trackEvent } from '../../utils/analytics';

const SHOP_URL = 'https://veloxco.com';

/**
 * Site-wide call-to-action hierarchy:
 *   1. Get started       primary; opens the chooser (profile, team, card)
 *                        or the enquiry when the page already implies the audience
 *   2. Velox for teams   homepage/default secondary, to /enterprise
 *      Get a card        professionals secondary, to the storefront
 *   3. Sign in           existing users, in the header/footer
 *
 * "Book a demo" must not return: it asked a visitor who was ready to start
 * to schedule a sales call instead. Cards are not a prerequisite; they live
 * inside the chooser rather than as an equal homepage button.
 */
const CTAGroup = ({
  source,
  primaryLabel = 'Get started',
  intent,
  showSecondary = true,
  secondary = 'teams',
  secondaryLabel,
  align = 'start',
}) => {
  const { openGetStarted, openEnquiry } = useGetStarted();
  const resolvedSecondaryLabel =
    secondaryLabel || (secondary === 'shop' ? 'Get a card' : 'Velox for teams');

  return (
    <div className={`${styles.group} ${align === 'center' ? styles.centred : ''}`}>
      <button
        type="button"
        className="vxm-btn vxm-btn--primary"
        onClick={() => {
          trackEvent('Marketing CTA', 'get_started_click', source);
          if (intent) {
            openEnquiry(intent);
          } else {
            openGetStarted();
          }
        }}
      >
        {primaryLabel}
      </button>

      {showSecondary && secondary === 'shop' && (
        <a
          href={SHOP_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="vxm-btn vxm-btn--secondary"
          onClick={() => trackEvent('Marketing CTA', 'shop_click', source)}
        >
          {resolvedSecondaryLabel}
        </a>
      )}

      {showSecondary && secondary === 'teams' && (
        <Link to="/enterprise" className="vxm-btn vxm-btn--secondary">
          {resolvedSecondaryLabel}
        </Link>
      )}
    </div>
  );
};

export const InlineSignIn = () => (
  <p className={styles.signIn}>
    Already have a Velox account?{' '}
    <Link to="/login" className="vxm-link">Sign in</Link>
  </p>
);

export default CTAGroup;
